module.exports = __webpack_public_path__ + "static/img/business18.dfeeb39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business18.jpg
// module id = FDvd
// module chunks = 9